import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VRow,_vm._l((_vm.items),function(section,idx){return _c(VCol,{key:`daily-${idx}`,attrs:{"cols":"12"}},[_c('summary-section',{attrs:{"section-label":section.label,"items":section.items,"category":_vm.category}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }